import React from "react";
import classnames from "classnames";

import "./style.scss";

const CorneredCard = ({
  children,
  size = "small",
  color = "white",
  className = ""
}) => (
  <div className={classnames("cornered-card", size, color, className)}>
    {children}
  </div>
);

export default CorneredCard;
